module.exports = __webpack_public_path__ + "static/img/fish40.4856c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish40.png
// module id = b+B6
// module chunks = 0